import { Component, HostBinding, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SvgTemplateService } from "app/common/services/svg-template.service";

@Component({
  selector: '[core-menu-horizontal-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuHorizontalItemComponent {
  @Input()
  item: any;
  svgContent!: SafeHtml;

  constructor(
    private sanitizer: DomSanitizer,
    private svgTemplateService: SvgTemplateService
  ) {}

  ngOnInit() {
    if (!this.item.isFeatherIcon) {
      this.svgContent = this.sanitizer.bypassSecurityTrustHtml(
        this.svgTemplateService.getTemplate(this.item.icon)
      );
    }
  }
}
